import React from 'react';
import {Button, Modal} from 'antd';
import './index.scss';

export function ActionBar({count, onClear, onDelete, onMove, loading}: any) {
  if (count === 0) return null;

  return (
    <div className="drive-action-bar">
      <div className="drive-action-bar__summary">
        <div className="drive-action-bar__text">
          已选择 <span className="drive-action-bar__count">{count}</span> 项
        </div>

        <Button type="link" size="small" onClick={onClear}>
          取消全选
        </Button>
      </div>

      <div className="drive-action-bar__actions">
        <Button onClick={onMove}>移动</Button>

        <Button
          danger
          type="primary"
          loading={loading}
          onClick={() => {
            Modal.confirm({
              title: '确认删除？',
              content: '删除后不可恢复',
              okText: '删除',
              okType: 'danger',
              onOk: onDelete
            });
          }}>删除</Button>
      </div>
    </div>
  );
}